import React, { SVGProps } from 'react';

export const CloseIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 20,
  height = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_702_40)">
        <path
          d="M2.93008 17.0701C1.97498 16.1476 1.21316 15.0442 0.689065 13.8241C0.164975 12.6041 -0.110887 11.2919 -0.122425 9.96409C-0.133963 8.6363 0.119054 7.3195 0.621863 6.09054C1.12467 4.86158 1.8672 3.74506 2.80613 2.80613C3.74506 1.8672 4.86158 1.12467 6.09054 0.621863C7.3195 0.119054 8.6363 -0.133963 9.96409 -0.122425C11.2919 -0.110887 12.6041 0.164975 13.8241 0.689065C15.0442 1.21316 16.1476 1.97498 17.0701 2.93008C18.8917 4.8161 19.8996 7.34212 19.8768 9.96409C19.854 12.5861 18.8023 15.0942 16.9483 16.9483C15.0942 18.8023 12.5861 19.854 9.96409 19.8768C7.34212 19.8996 4.8161 18.8917 2.93008 17.0701ZM4.34008 15.6601C5.8412 17.1612 7.87717 18.0045 10.0001 18.0045C12.123 18.0045 14.159 17.1612 15.6601 15.6601C17.1612 14.159 18.0045 12.123 18.0045 10.0001C18.0045 7.87717 17.1612 5.8412 15.6601 4.34008C14.159 2.83895 12.123 1.99563 10.0001 1.99563C7.87717 1.99563 5.8412 2.83895 4.34008 4.34008C2.83895 5.8412 1.99563 7.87717 1.99563 10.0001C1.99563 12.123 2.83895 14.159 4.34008 15.6601ZM14.2401 7.17008L11.4101 10.0001L14.2401 12.8301L12.8301 14.2401L10.0001 11.4101L7.17008 14.2401L5.76008 12.8301L8.59008 10.0001L5.76008 7.17008L7.17008 5.76008L10.0001 8.59008L12.8301 5.76008L14.2401 7.17008Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_702_40">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
